export default class PaginaTamanho {
    static get GRID_CAR_ESTADO() {
        return 7;
    }

    static get GRID_CAR_INCRA() {
        return 7;
    }

    static getByName(name) {
        if (!name) return;
        name = name.toUpperCase();
        return PaginaTamanho[name];
    }
}
